import { phoneMask } from "../utils/mask";

const phoneInput = document.getElementById("formatted");
phoneMask(phoneInput);
